import { render, staticRenderFns } from "./MyCoursesNavigation.vue?vue&type=template&id=f7b1b330&"
import script from "./MyCoursesNavigation.vue?vue&type=script&lang=js&"
export * from "./MyCoursesNavigation.vue?vue&type=script&lang=js&"
import style0 from "./MyCoursesNavigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/studip/studip/studip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7b1b330')) {
      api.createRecord('f7b1b330', component.options)
    } else {
      api.reload('f7b1b330', component.options)
    }
    module.hot.accept("./MyCoursesNavigation.vue?vue&type=template&id=f7b1b330&", function () {
      api.rerender('f7b1b330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/MyCoursesNavigation.vue"
export default component.exports